/**
 * Define constants for mutations here so that there is a central store of what they are
 */
const path = 'widgets/links';
export const SET_LINKS = `${path}/SET_LINKS`;
export const SET_FILTER_LIMIT = `${path}/SET_FILTER_LIMIT`;
export const SET_MAX_QUERY_SIZE = `${path}SET_MAX_QUERY_SIZE`;